import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import qrLogo from "../../assets/logo.png"; // Replace with your logo path

const playStoreUrl =
  "https://play.google.com/store/apps/details?id=com.WaveTech&pcampaignid=web_share"; // Your Play Store URL

const QRWithLogo = () => {
  const [isLoading, setIsLoading] = useState(true);

  const handleLogoLoad = () => setIsLoading(false);

  return (
    <div className="flex items-center gap-6 p-4 bg-white shadow-lg rounded-lg max-w-md">
      {/* QR Code Container */}
      <div className="relative w-32 h-32">
        {/* Spinner */}
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white/70 z-10 rounded">
            <div className="w-6 h-6 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
          </div>
        )}

        {/* QR Code */}
        <QRCodeCanvas
          value={playStoreUrl}
          size={128}
          bgColor="#ffffff"
          fgColor="#000000"
          includeMargin={false}
        />

        {/* Center Logo */}
        <img
          src={qrLogo}
          alt="App Logo"
          onLoad={handleLogoLoad}
          className="absolute top-1/2 left-1/2 w-10 h-10 transform -translate-x-1/2 -translate-y-1/2 rounded-md bg-white p-1 shadow-md z-20"
        />
      </div>

      {/* Text Content */}
      <div className="space-y-1">
        <p className="text-gray-500 text-sm">Scan to Download</p>
        <h2 className="text-xl font-semibold text-gray-800 leading-snug">
          Available on <br /> Play Store
        </h2>
      </div>
    </div>
  );
};

export default QRWithLogo;
